module.exports = __webpack_public_path__ + "static/media/user.233760b5.svg";